import { WorkOrderPriority } from '@gearbelt/global';
import { match } from 'ts-pattern';

export const getWorkOrderPriorityColorClass = (priority: WorkOrderPriority) => {
  return match(priority)
    .with(WorkOrderPriority.Low, () => 'bg-grey-1 border-grey-5')
    .with(WorkOrderPriority.Medium, () => 'bg-default-light-yellow border-default-yellow')
    .with(WorkOrderPriority.High, () => 'bg-default-light-red border-default-red')
    .with(WorkOrderPriority.Critical, () => 'bg-default-light-red border-default-red')
    .otherwise(() => '');
};
